import styles from "./FeatureEntities.module.scss";
import classNames from "classnames";
import { ImageCheck, LoadingSimpleComponent } from "..";
import {
  ImageCheckType,
  ImageType,
  SkeletonType,
} from "Explore/Config/ImageType";
import { Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Fragment } from "react";

const FeatureInstitutionItem = ({ data, isLoading }) => {
  const statistics = [
    { value: data?.total_publication, icon: IconPack.publications },
    { value: data?.total_citation, icon: IconPack.citation },
    { value: data?.total_h_index, icon: IconPack.h_index },
    { value: data?.total_faculties, icon: IconPack.unit_faculty_members },
  ].filter((e) => !!e.value);

  return (
    <div
      className={classNames(styles["institution-item"], styles["list--item"])}
    >
      <LoadingSimpleComponent
        className={styles["list--item--cover"]}
        isLoading={isLoading}
        type={SkeletonType.COVER_IMAGE}
        component={
          <ImageCheck
            url={`https://media.academic.online/institutions_images/${data?.id}/${ImageType.LANDSCAPE}.png`}
            className={styles["list--item--img"]}
            type={ImageCheckType.INSTITUTION_LANDSCAPE}
          />
        }
      />
      <div className={styles["list--item__content"]}>
        <div className={styles["list--item__content__header"]}>
          <LoadingSimpleComponent
            className={styles["institution-item--brief"]}
            isLoading={isLoading}
            type={SkeletonType.PARAGRAPH}
            component={
              <>
                <p className={styles["list--item--name"]}>{data?.name}</p>
                <p className={styles["institution-item--rank"]}>
                  {(data?.rankingKeywords || []).slice(0, 2).map((data, i) => (
                    <Fragment key={i}>
                      {`#${data.rank} in ${data.keyword}`}
                      {i !== 1 && <br />}
                    </Fragment>
                  ))}
                </p>
              </>
            }
          />
          <LoadingSimpleComponent
            className={styles["list--item--avatar"]}
            isLoading={isLoading}
            type={SkeletonType.COVER_IMAGE}
            component={
              <ImageCheck
                url={`https://media.academic.online/institutions_images/${data?.id}/${ImageType.SEAL}.png`}
                className={styles["list--item--img"]}
                type={ImageCheckType.INSTITUTION_LOGO}
              />
            }
          />
        </div>
        <LoadingSimpleComponent
          className={styles["list--item__content__body"]}
          isLoading={isLoading}
          type={SkeletonType.PARAGRAPH}
          component={
            <>
              <div className={styles["list--item--statistics"]}>
                {statistics.map((item, index) => (
                  <div
                    className={styles["list--item--statistics--item"]}
                    key={index}
                  >
                    {item.icon}
                    {numberRegex(item.value)}
                  </div>
                ))}
              </div>
              <p className={styles["list--item--description"]}>{data?.bio}</p>
            </>
          }
        />
        <div className={styles["list--item__content__footer"]}>
          <Button
            className={styles["list--item--btn"]}
            variant="outlined"
            href={`/explore/institution/${data?.explore_slug || data?.id}`}
            endIcon={<KeyboardArrowRightIcon />}
            disabled={isLoading}
            size="small"
          >
            Explore
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeatureInstitutionItem;
